export const ANALYZE_TYPE: any = {
  INGREDIENT: "aiChef.goToIngredient",
  MEAL: "aiChef.goToRecipe",
};